import { Tabs } from "antd";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";

import { DetailInstrumentChart } from "../DetailInstrumentChart";
import { fetchResumenHistorico } from "../../utils/fetchers";
import { __ } from "../../locales/translation";

import Comparator from "./Comparator";
import VariationSelectors from "./VariationSelectors";

export default function ProductDetailTabs() {
    const { productId } = useParams();

    const onChange = (key) => {
        console.log(key);
    };

    const { isLoading, data } = useQuery({
        queryKey: ["resumenHistorico", productId],
        queryFn: () => fetchResumenHistorico(productId),
    });

    const [firstItem] = data || [];

    const items = [
        {
            key: "1",
            label: `${__("Resumen")}`,
            children: (
                <div className="cot-chart-container">
                    {!firstItem?.empty ? (
                        <>
                            <DetailInstrumentChart apiData={firstItem?.valuaciones || []} />

                            <VariationSelectors data={firstItem?.variacion} />
                        </>
                    ) : (
                        <h2 className="paragraph">{__("No se encontraron datos para visualizar el gráfico.")}</h2>
                    )}
                </div>
            ),
        },
        {
            key: "2",
            label: `${__("Comparador")}`,
            children: (
                <div className="cot-chart-container">
                    {!firstItem?.empty ? (
                        <Comparator />
                    ) : (
                        <h2 className="paragraph">{__("No se encontraron datos para visualizar el gráfico.")}</h2>
                    )}
                </div>
            ),
        },
        // {
        //     key: "3",
        //     label: `${__("Datos históricos")}`,
        //     children: <HistoricDataTable item={descripcion} />,
        // },
    ];

    return (
        <div className="cot-prod-detail-tabs">
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        </div>
    );
}
